const withdrawList = {
  AUTO_PURCHASE: false,
  PURCHASE: false,
  CASHOUT: false,
};

export default withdrawList;
